import { useMutation } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { postAcceptInvitation } from "./postAcceptInvitation";
import { TData, TAcceptInvitationBody } from "./types";
import { translations } from "../../../i18n/translations";
import { setAccessToken } from "../../../utils/setAccessToken";

export const useAcceptInvitation = () => {
  const toast = useToast();
  return useMutation<TData, unknown, TAcceptInvitationBody>(
    (payload) => postAcceptInvitation(payload),
    {
      onError: () => {
        toast({
          title: "Error",
          description: t<string>(translations.errors.accept_invitation_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: (data) => {
        setAccessToken(data.accessToken);
      },
    }
  );
};
